import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/contasis';
import { useTipoCambio } from '@/contexts/ContextoTipoCambio';

export function TipoCambioWarningModal() {
  const { sinTipoCambio, refrescar } = useTipoCambio();
  const [cargando, setCargando] = useState(false);

  if (!sinTipoCambio) return null;

  const handleReintentar = async () => {
    setCargando(true);
    try {
      await refrescar();
    } finally {
      setCargando(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-surface-0 rounded-2xl shadow-xl border border-warning/40 w-full max-w-md mx-4 p-8">
        <div className="flex flex-col items-center text-center gap-5">
          <div className="w-14 h-14 rounded-full bg-warning/10 flex items-center justify-center">
            <AlertTriangle className="w-7 h-7 text-warning" />
          </div>

          <div className="space-y-2">
            <h2 className="text-h4 font-display text-primary">Tipo de Cambio no disponible</h2>
            <p className="text-body-sm text-secondary">
              No se encontró el tipo de cambio para el día de hoy. Esta información es necesaria
              para operar correctamente el sistema.
            </p>
          </div>

          <div className="w-full p-4 bg-warning/5 border border-warning/30 rounded-lg text-left">
            <p className="text-body-sm text-warning-700 dark:text-warning-400 font-medium">
              Sin el tipo de cambio del día no podrás realizar operaciones en moneda extranjera.
              Verifica tu conexión a internet e intenta nuevamente.
            </p>
          </div>

          <Button
            variant="primary"
            size="md"
            onClick={handleReintentar}
            loading={cargando}
            loadingText="Consultando..."
            icon={<RefreshCw className="w-4 h-4" />}
            className="w-full"
          >
            Reintentar
          </Button>
        </div>
      </div>
    </div>
  );
}


